<div class="content-container bg-white">
  <h1 translate="statistics.title"></h1>

  <form [formGroup]="filter.formGroup">

    <div class="row">

      <!-- Service Filter -->
      <div class="default-filter-form-field">
        <label class="form-label" translate="statistics.service"></label>
        <select class="form-control form-select" id="service" name="service"
          (change)="loadServiceStatisticsData()"
          [formControl]="service">
          <option [ngValue]="null">-</option>
          @for (service of filter.servicesDropdownList; track service) {
            <option
            [ngValue]="service.serviceId">{{ service['name' + crtLang.toUpperCase()] }}</option>
          }
        </select>
      </div>

      <!-- Period Filter -->
      <div class="default-filter-form-field">
        <app-date-period-picker [periodControl]="period"
          (dateFromSelected)="loadServiceStatisticsData()"
          (dateToSelected)="loadServiceStatisticsData()"
          (dateFromReset)="loadServiceStatisticsData()"
        (dateToReset)="loadServiceStatisticsData()"></app-date-period-picker>
      </div>
    </div>

  </form>

  <h3 translate="statistics.hourlyUsageTitle"></h3>

  @if (filter.formGroup.invalid) {
    <div>
      @if (service.invalid) {
        <p class="text-center" translate="statistics.noServiceSelected"></p>
      }
      @if (period.invalid) {
        <p class="text-center" translate="statistics.invalidPeriodSelected"></p>
      }
    </div>
  }

  @if (filter.formGroup.valid && statisticsLoaded) {
    <div>
      <canvas baseChart
        [data]="barChartData"
        [legend]="true"
        [type]="'bar'">
      </canvas>
    </div>
  }

</div>


